import React, { Component } from "react";
import { Container, Grid, Button, Statistic } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { APP_NAME } from "../../constants/resource.constants";
import NavBar from "../../components/NavBar/NavBar";
import {
  HOME_ROUTE,
  CONTACT_ROUTE,
  BASE_URL
} from "../../constants/route.constants";
import Footer from "../../components/Footer/FooterView";

export default class TermsPage extends Component {
  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }
  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container text>
          <Helmet>
            <title>Error | {APP_NAME}</title>
            <meta name="description" content="" />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`Error | ${APP_NAME}`} />
            <meta property="og:description" content="" />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}`}
            />
          </Helmet>
          <Grid columns={2} stackable={true}>
            <Grid.Column>
              <Statistic size="huge">
                <Statistic.Value>404</Statistic.Value>
              </Statistic>
              <h1>Just wide of the mark!</h1>
              <p>
                The page you are looking for was moved, removed, renamed or
                might never have existed.
              </p>
              <Link to={HOME_ROUTE}>
                <Button size="big" negative>
                  Home
                </Button>
              </Link>
              <Link to={CONTACT_ROUTE}>
                <Button size="big" negative>
                  Contact Us
                </Button>
              </Link>
            </Grid.Column>
            <Grid.Column />
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

TermsPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/ErrorPage/View.js